import { useCallback, useMemo, useState } from 'react';
const DISMISS_KEY_PREFIX = 'dynamic-banner:dismissed:';
export function isDismissableDesignType(designType) {
  return typeof designType === 'string' && designType.includes('DISMISSIBLE');
}
function getHighestPriorityBanners(banners) {
  if (banners.length === 0) {
    return [];
  }
  const minPriority = Math.min(...banners.map(b => b.priority));
  return banners.filter(b => b.priority === minPriority);
}
function getDismissKey(banner) {
  return `${DISMISS_KEY_PREFIX}${String(banner.bannerName)}`;
}
function readDismissedFromStorage(banner) {
  if (!isDismissableDesignType(banner.designType)) {
    return false;
  }
  try {
    return window.localStorage.getItem(getDismissKey(banner)) === 'true';
  } catch (_unused) {
    return false;
  }
}
export function useDynamicBanners(rawBanners) {
  const [dismissedKeys, setDismissedKeys] = useState(new Set());
  const visibleBanners = useMemo(() => {
    const highestPriority = getHighestPriorityBanners(rawBanners);
    return highestPriority.filter(b => {
      if (!isDismissableDesignType(b.designType)) {
        return true;
      }
      const key = getDismissKey(b);
      return !dismissedKeys.has(key) && !readDismissedFromStorage(b);
    });
  }, [rawBanners, dismissedKeys]);
  const dismissBanner = useCallback(banner => {
    const key = getDismissKey(banner);
    try {
      window.localStorage.setItem(key, 'true');
    } catch (e) {
      console.error(e);
    }
    setDismissedKeys(prev => new Set(prev).add(key));
  }, []);
  return {
    banners: visibleBanners,
    dismissBanner
  };
}